import events$ from '@/services/Events'
import loading$ from '@/services/Loading'

import { STORAGE_KEY } from '@/config/constants'
import { EVENT_OVP } from '@/config/events'

import useBasket from '@/hooks/useBasket'
import useLogger from '@/hooks/useLogger'
import useSession from '@/hooks/useSession'

// Hooks
const { persistBasket } = useBasket()
const { logError, logInfo } = useLogger()
const { resumeSession, setSession } = useSession()

// Data
let eventHandler = false

// Methods
function registerSync() {
  if (eventHandler) {
    throw new Error('Sync-EventHandler already registered')
  }

  eventHandler = handleChangeEvent
  // window.addEventListener('storage', eventHandler)

  logInfo('REGISTER SYNC')
}

function unregisterSync() {
  logInfo('UNREGISTER SYNC')

  if (!eventHandler) {
    throw new Error('No Sync-EventHandler registered')
  }

  // window.removeEventListener('storage', eventHandler)
  eventHandler = false
}

async function syncSession(basketFromStorage) {
  loading$.start()

  const __basket = await resumeSession(basketFromStorage)

  await setSession(__basket)
  await persistBasket(__basket)

  loading$.end()
}

function handleChangeEvent(event) {
  if (event.key !== STORAGE_KEY) return

  if (event.newValue === null) {
    window.open(window.location.href.replace(/(\/?#).*/, ``), '_self')
    return
  }

  try {
    if (isSyncNecessary(event)) {
      syncSession(JSON.parse(event.newValue))
      logInfo('SESSION SYNCED')
      events$.emit(EVENT_OVP.SYNC_EXECUTED)
    }
  } catch (error) {
    logError(['Failed to sync session after local storage update\n', error, event.oldValue, event.newValue])
    return error
  }
}

function isSyncNecessary(event) {
  const oldValue = JSON.parse(event.oldValue)
  const newValue = JSON.parse(event.newValue)

  if (oldValue?.updateDate === undefined && newValue?.updateDate === undefined) return false

  return oldValue?.updateDate !== newValue?.updateDate
}

export default function useSync() {
  return {
    registerSync,
    unregisterSync,
  }
}
